module.exports = __webpack_public_path__ + "img/shippingbannermini_en.5e93c156.png";